import { Fancybox } from '@fancyapps/ui';

export class WpBlockGallery {
  constructor() {
    this.init();
  }

  init() {
    return new Promise((resolve, reject) => {
      this.bindListeners();
      resolve();
    });
  }

  bindListeners() {
    const _this = this;

    document
      .querySelectorAll('.wp-block-gallery')
      ?.forEach((gallery, index) => _this.addFancybox(gallery, index));
  }

  addFancybox(e, i) {
    return new Promise((resolve, reject) => {
      if (e) {
        e.querySelectorAll('a')?.forEach((link) => {
          link.setAttribute('target', '_blank');
          link.setAttribute('data-fancybox', `gallery-${i}`);
          Fancybox.bind(`[data-fancybox="gallery-${i}"]`, {
            caption: function (fancybox, carousel, slide) {
              return `${slide.index + 1} / ${carousel.slides.length} <br />` + slide.caption;
            },
          });
        });
      }

      resolve();
    });
  }
}
